import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import './style.css';

const BOTTOM = 'bottom',
LEFT = 'left',
RIGHT = 'right',
TOP = 'top';

/**
 * @name ToolTip
 * @function
 * @description Displays a tooltip
 * @returns {JSX}
 * @param {*} props 
 */
function ToolTip( props ){ 

    const containerRef = useRef( null );

    useEffect(() => {

        if( props.coords && containerRef.current ){

            let bounding = containerRef.current.getBoundingClientRect(),
            left =  props.coords.left;
    
            switch( props.side ){
                default:
                    left = ( left - ( bounding.width / 2 ) );
                    containerRef.current.style.left = left + 'px';
                    break;
            }
    
        }

    });

    return (
        <div className={ `${ props.side } tooltip` } ref={ containerRef }>
            <span dangerouslySetInnerHTML={{ __html: props.label }} />
        </div>
    );
}

ToolTip.defaultProps = {
    side: BOTTOM
};

ToolTip.propTypes = {
    coords: PropTypes.shape({
        left: PropTypes.number
    }),
    label: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]).isRequired,
    side: PropTypes.oneOf([ BOTTOM, LEFT, RIGHT, TOP ])
};

export default ToolTip;